import React, { Component } from 'react';

import { authService } from '../../../../services/auth';

import './account-dropdown.scss';

class AccountDropdown extends Component {
	constructor(props) {
		super(props);

		this.AuthService = authService;

		this.merchantMenu = [
			{
				title: 'Account',
				url: '/#/merchant/account',
				group: 'settings',
			},
		];

		this.publisherMenu = [
			{
				title: 'Account',
				url: '/#/publisher/account',
				group: 'settings',
			},
		];

		this.fullname = '';
		this.dropdownNode = null;
	}

	componentDidMount() {
		window.addEventListener('click', this.handleClick.bind(this), false);
	}

	componentWillUnmount() {
		window.removeEventListener('click', this.handleClick.bind(this), false);
	}

	handleClick(event) {
		if (this.dropdownNode && !this.dropdownNode.contains(event.target)) {
			this.dropdownNode.classList.remove('open');
		}
	}

	getMenu() {
		if (!this.props.currentUser) return [];

		switch (this.props.userRole) {
			case 'merchant':
				return this.merchantMenu;
			case 'publisher':
				return this.publisherMenu;
			default:
				return [];
		}
	}

	toggleDropdown() {
		this.dropdownNode.classList.toggle('open');
	}

	logout() {
		this.AuthService.logout(true);
	}

	render() {
		this.fullname = `${this.props.currentUser.firstName} ${this.props.currentUser.lastName}`;

		return (
			<div
				ref={(node) => this.dropdownNode = node}
				className="account-dropdown">
				<div
					className="dropdown-toggle"
					tabIndex={0}
					onClick={this.toggleDropdown.bind(this)}>
					<span>{this.fullname}</span>
					<span className="narrativ-icon down"></span>
				</div>
				<ul className="dropdown-menu">
					{this.getMenu().map((item, i) => {
						return (
							<li key={i}
								className={item.title.toLowerCase()}
								onClick={() => window.location = item.url}>
								{item.title}
							</li>
						);
					})}
					<li className="logout"
						onClick={this.logout.bind(this)}>
						Sign out
					</li>
				</ul>
			</div>
		);
	}
}

export default AccountDropdown;
